import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@material-ui/core'
import { Language, ArrowDropDown } from '@material-ui/icons'

const MenuListItemIcon = styled(ListItemIcon)`
  min-width: 40px;
`
const MenuListItemText = styled(ListItemText)`
  padding-left: 0;
`

const LanguageButton = styled.div`
  display: flex;
  flex-align: flex-start;
  padding: ${props => props.theme.spacing(2)}px
    ${props => props.theme.spacing(4)}px ${props => props.theme.spacing(2)}px
    ${props => props.theme.spacing(2)}px;
  font-size: 0.778rem;
  color: ${props => props.theme.palette.text.secondary};
  background-color: transparent;
  text-transform: uppercase;
  cursor: pointer;
`

const LanguageSelect = () => {
  const [anchorEl, setAnchorEl] = useState(null)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <LanguageButton
        aria-describedby={id}
        onClick={handleClick}
        style={{
          marginTop: '24px',
          marginLeft: '24px',
          marginRight: '24px',
          textAlign: 'left',
        }}
      >
        <Language style={{ marginRight: '16px' }} /> English
        <ArrowDropDown style={{ marginLeft: '24px' }} fontSize="small" />
      </LanguageButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{ width: '100%' }}
      >
        <List component="language">
          <ListItem button component={Link} to="">
            <MenuListItemIcon>
              <Language />
            </MenuListItemIcon>
            <MenuListItemText
              inset
              primary="English"
              style={{ marginRight: '32px', marginLeft: '8px' }}
            />
          </ListItem>
          <ListItem button component={Link} to="">
            <MenuListItemIcon>
              <Language />
            </MenuListItemIcon>
            <MenuListItemText
              inset
              primary="French"
              style={{ marginRight: '32px', marginLeft: '8px' }}
            />
          </ListItem>
          <ListItem button component={Link} to="">
            <MenuListItemIcon>
              <Language />
            </MenuListItemIcon>
            <MenuListItemText
              inset
              primary="German"
              style={{ marginRight: '32px', marginLeft: '8px' }}
            />
          </ListItem>
          <ListItem button component={Link} to="">
            <MenuListItemIcon>
              <Language />
            </MenuListItemIcon>
            <MenuListItemText
              inset
              primary="Greek"
              style={{ marginRight: '32px', marginLeft: '8px' }}
            />
          </ListItem>
          <ListItem button component={Link} to="">
            <MenuListItemIcon>
              <Language />
            </MenuListItemIcon>
            <MenuListItemText
              inset
              primary="Spanish"
              style={{ marginRight: '32px', marginLeft: '8px' }}
            />
          </ListItem>
        </List>
      </Popover>
    </>
  )
}

export default LanguageSelect
